import React, { useCallback } from 'react';
import cn from 'classnames';
import { toMediaSrcFile } from '../../utils/DeviationMediaService/helpers';
import s from './Attachment.scss';
const Attachment = ({ attachment, width, height, className, onSelect })=>{
    const onClick = useCallback(()=>onSelect && onSelect(attachment), [
        onSelect,
        attachment
    ]);
    const selectedMediaType = attachment.media.types[0];
    const thumbData = toMediaSrcFile(attachment, selectedMediaType);
    if (!thumbData) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: cn(s['root'], className),
        style: {
            width,
            height
        },
        onClick: onClick
    }, /*#__PURE__*/ React.createElement("img", {
        src: thumbData.src,
        alt: attachment.filename
    }));
};
Attachment.displayName = 'Attachment';
export default Attachment;

//# sourceMappingURL=Attachment.js.map